/**
 * AttachmentIcon/index.js
 * desc: message attachment icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';
import './styles.css';


const AttachmentIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="attachment icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.attachment.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 32 16" xmlns="http://www.w3.org/2000/svg"><path d="M24.727 13.818H8A5.817 5.817 0 012.182 8 5.817 5.817 0 018 2.182h18.182a3.638 3.638 0 013.636 3.636 3.638 3.638 0 01-3.636 3.637H10.909c-.8 0-1.454-.655-1.454-1.455s.654-1.455 1.454-1.455h13.818V4.364H10.91A3.638 3.638 0 007.273 8a3.638 3.638 0 003.636 3.636h15.273A5.817 5.817 0 0032 5.818 5.817 5.817 0 0026.182 0H8C3.578 0 0 3.578 0 8c0 4.422 3.578 8 8 8h16.727v-2.182z"/></svg>
    </IconButton>
);


export default AttachmentIcon;
